import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getBestSellingProducts, getProductsByCategory } from '../data/products';
import categories from '../data/categories';
import '../styles/HomePage.css';

// 카테고리 ID에 따른 상품 ID 매핑 함수
const getProductIdForCategory = (categoryId) => {
  // 카테고리 ID에 따라 해당하는 상품 ID 반환
  const categoryToProductMap = {
    'reunion': 1,
    'compatibility': 2,
    'marriage': 3,
    'love': 4,
    'newyear': 5,
    'career': 6,
    'wealth': 7,
    // trial과 free는 카테고리 페이지로 이동
    'trial': null,
    'free': null
  };
  
  return categoryToProductMap[categoryId];
};

const HomePage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('saju');
  const bestProducts = getBestSellingProducts(2);
  
  // 활성 탭에 따라 베스트 상품 필터링
  const filteredProducts = activeTab === 'saju'
    ? bestProducts
    : getProductsByCategory('cat_tarot_love').concat(getProductsByCategory('cat_tarot_future')).slice(0, 2);

  return (
    <div className="home-page">
      {/* Banner Section */}
      <div className="banner">
        <div className="banner-content">
          <p className="banner-title">{t('tarot_new')}</p>
          <p className="banner-desc">{t('tarot_desc')}</p>
        </div>
        <div className="banner-image">
          <div className="new-tag">NEW</div>
          <div style={{ width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.2)', backdropFilter: 'blur(4px)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
            <span style={{ color: 'white', fontWeight: '500', textShadow: '0 1px 2px rgba(0,0,0,0.2)' }}>Tarot Card</span>
          </div>
        </div>
      </div>

      {/* Category Tabs */}
      <div className="category-tabs">
        <button 
          onClick={() => setActiveTab('saju')} 
          className={`tab ${activeTab === 'saju' ? 'active' : ''}`}
        >
          {t('cat_saju')}
        </button>
        <button 
          onClick={() => setActiveTab('tarot')} 
          className={`tab ${activeTab === 'tarot' ? 'active' : ''}`}
        >
          {t('cat_tarot')}
        </button>
      </div>

      {/* Category Grid - 활성 탭에 따라 다른 카테고리 표시 */}
      <div className="category-section">
        <h2>{activeTab === 'saju' ? t('fortune_categories') : t('tarot_categories')}</h2>
        <div className="category-grid">
          {categories
            .filter(category => {
              // 활성 탭에 따라 카테고리 필터링
              if (activeTab === 'saju') {
                return !category.id.startsWith('tarot_');
              } else {
                return category.id === 'tarot_love' || category.id === 'tarot_future' || category.id === 'tarot_career';
              }
            })
            .map(category => {
            // 카테고리에 따라 직접 상품 ID로 연결
            const productId = getProductIdForCategory(category.id);
            // 상대방 생년월일이 필요한지 확인
            const requiresPartner = category.requiresPartner;
            // 생년월일 정보가 필요한지 확인
            const requiresBirthInfo = category.requiresBirthInfo;
            
            // 모든 카테고리는 생년월일 입력 페이지로 이동
            let linkTo = `/categories/${category.id}`;
            
            // 생년월일 정보가 필요한 경우
            if (requiresBirthInfo && productId) {
              linkTo = `/birth-input?product=${productId}&requiresPartner=${requiresPartner}`;
            }
              
            return (
              <Link 
                to={linkTo} 
                className="category-item" 
                key={category.id}
              >
                <div className="icon">{category.icon}</div>
                <p>{t(category.nameKey)}</p>
              </Link>
            );
          })}
        </div>
      </div>

      {/* Best Items Section */}
      <div className="best-items-section">
        <h2>{activeTab === 'saju' ? t('best_items_saju') : t('best_items_tarot')}</h2>
        <div className="best-items">
          {filteredProducts.map(product => (
            <Link 
              to={`/product/${product.id}`} 
              className="product-card" 
              key={product.id}
            >
              <div className="product-image">
                <div className="placeholder-image" style={{ width: '100%', height: '100%', backgroundColor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
                  <span style={{ padding: '0.5rem', textAlign: 'center' }}>{t(product.titleKey)}</span>
                </div>
                <div className="tag">{t(product.category)}</div>
              </div>
              <div className="product-info">
                <div className="price">
                  <span className="original">
                    {new Intl.NumberFormat().format(product.originalPrice)}
                  </span>
                  <span className="discount">{product.discountRate}%</span>
                  <span className="final">
                    {new Intl.NumberFormat().format(product.finalPrice)}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
